import Vue from "vue";
import Router from "vue-router";

// 导入组件
const CustomerIndex = () => import("@/views/customer/index.vue");
const VantDemo = () => import("@/views/vant-demo.vue");
const CustomerSearch = () => import("@/views/customer/search.vue");
const AddGroup = () => import("@/views/customer/add-group.vue");
const ModifyGroup = () => import("@/views/customer/modify-group.vue");
const CustomerDetail = () => import("@/views/customer/detail.vue");
const CustomerBind = () => import("@/views/customer/bind_friend.vue");
const CustomerBindIdentity = () => import("@/views/customer/sel_contact.vue");
const CustomerBindByInput = () => import("@/views/customer/cus_bind.vue");
const OrderList = () => import("@/views/customer/order-list.vue");
const WorkorderList = () => import("@/views/customer/workorder-list.vue");
const CusSel = () => import("@/views/common/cus_sel.vue");
const IntentionDetail = () => import("@/views/customer/thread.vue");
const DemoPage = () => import("@/views/common/demo.vue");

const ScheduleIndex = () => import("@/views/schedule/index.vue");
const ScheduleList = () => import("@/views/schedule/list.vue");
const ScheduleHandle = () => import("@/views/schedule/todo-handle.vue");
const ScheduleDetail = () => import("@/views/schedule/detail.vue");
const ClueRegistration = () => import("@/views/schedule/add-thread.vue");
const ThreadDetail = () => import("@/views/schedule/thread-detail.vue");
const TaskDetail = () => import("@/views/schedule/TaskDetail.vue");

// 使用路由插件
Vue.use(Router);

// 创建并导出路由实例
const router = new Router({
  mode: "hash",
  base: "/", 
  routes: [
    {
      path: "/customer/index/:orgCode",
      name: "CustomerIndex",
      component: CustomerIndex,
      meta: {
        title: "客户列表",
      },
    },
    {
      path: "/vant",
      name: "VantDemo",
      component: VantDemo,
      meta: {
        title: "Vant演示",
      },
    },
    {
      path: "/app/wecom/login",
      name: "WecomLogin",
      component: () => import("@/views/customer/wecom-login.vue"),
      meta: {
        title: "企业微信登录",
      },
    },
    {
      path: "/customer/search",
      name: "CustomerSearch",
      component: CustomerSearch,
      meta: {
        title: "高级筛选",
      },
    },
    {
      path: "/customer/add-group",
      name: "AddGroup",
      component: AddGroup,
      meta: {
        title: "新增分组",
      },
    },
    {
      path: "/customer/modify-group",
      name: "ModifyGroup",
      component: ModifyGroup,
      meta: {
        title: "修改分组",
      },
    },
    {
      path: "/customer/detail/",
      name: "CustomerDetail",
      component: CustomerDetail,
      meta: {
        title: "客户详情",
      },
    },
    {
      path: "/schedule/index/:orgCode",
      name: "ScheduleIndex",
      component: ScheduleIndex,
      meta: {
        title: "日程管理",
      },
    },
    {
      path: "/schedule/list",
      name: "ScheduleList",
      component: ScheduleList,
      meta: {
        title: "日程列表",
      },
    },
    {
      path: "/schedule/handle",
      name: "ScheduleHandle",
      component: ScheduleHandle,
      meta: {
        title: "处理待办",
      },
    },
    {
      path: "/schedule/detail/:id",
      name: "ScheduleDetail",
      component: ScheduleDetail,
      meta: {
        title: "日程详情",
      },
    },
    {
      path: "/customer/bind",
      name: "CustomerBind",
      component: CustomerBind,
      meta: {
        title: "绑定客户",
      },
    },
    {
      path: "/customer/bind-identity",
      name: "CustomerBindIdentity",
      component: CustomerBindIdentity,
      meta: {
        title: "选择客户",
      },
    },
    {
      path: "/customer/bind/input",
      name: "CustomerBindByInput",
      component: CustomerBindByInput,
      meta: {
        title: "绑定确认",
      },
    },
    {
      path: "/demo",
      name: "Demo",
      component: DemoPage,
      meta: {
        title: "测试页面",
      },
    },
    {
      path: "/common/cus-sel",
      name: "CusSel",
      component: CusSel,
      meta: {
        title: "选择客户",
      },
    },
    {
      path: "/schedule/clue-registration",
      name: "ClueRegistration",
      component: ClueRegistration,
      meta: { title: "线索登记" },
    },
    {
      path: "/customer/order-list",
      name: "OrderList",
      component: OrderList,
      meta: { title: "全部订单" },
    },
    {
      path: "/customer/workorder-list",
      name: "WorkorderList",
      component: WorkorderList,
      meta: { title: "全部工单" },
    },
    {
      path: "/customer/intention-detail/:id",
      name: "IntentionDetail",
      component: IntentionDetail,
      meta: { title: "意向详情" },
    },
    {
      path: "/schedule/thread-detail/:id",
      name: "ThreadDetail",
      component: ThreadDetail,
      meta: {
        title: "线索详情",
      },
    },
    {
      path: "/schedule/TaskDetail",
      name: "TaskDetail",
      component: TaskDetail,
      meta: { title: "任务详情" },
    },
    // {
    //   path: "/schedule/thread-detail",
    //   name: "ThreadDetail",
    //   component: ThreadDetail,
    //   meta: {
    //     title: "线索详情",
    //   },
    // },
    
  ],
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

export default router;
